import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export const multipleAdsCreationFormStyles = css({
  flexDirection: 'column',
  margin: '16px ',
  marginLeft: '4px',
  'multiple-ads-creation-form': {
    width: '100%',
  },
  '.multiple-ads-creation-form': {
    '&__container': {
      flexDirection: 'column',
      backgroundColor: COLORS.WHITE,
      border: `1px solid ${COLORS.NEUTRAL200}`,
      borderRadius: '8px',
      padding: theme.space[4],
      overflow: 'none',
      marginTop: theme.space[5],
      [mediaquery.md]: {
        padding: theme.space[5],
      },
    },
    '&__form': {
      width: '100%',
      flexDirection: 'column',
    },
    '&__top-row': {
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '&__call-to-action-label': {
      marginBottom: theme.space[4],
    },
    '&__heading': {
      margin: `${theme.space[5]} 0 ${theme.space[3]}`,
    },
    '&__form-buttons': {
      gap: '16px',
      justifyContent: 'flex-end',
      marginTop: theme.space[7],
    },
    '&__brkfst-suffix': {
      marginBottom: theme.space[7],
    },
    '&__brkfst-suffix__input': {
      transform: 'scale(1.5)',
      marginLeft: theme.space[2],
    },
    '&--hidden': {
      display: 'none',
    },
    '&__call-to-action': {
      marginRight: theme.space[5],
    },
    '&__display-url': {
      width: '100%',
    },
    '&__dynamic-vars-heading': {
      marginTop: '20px',
      gap: theme.space[3],
    },
  },
  '&.multiple-ads-prompt': {
    margin: '16px',
  },
  '.multiple-ads-prompt': {
    '&__ad-limit-header': {
      gap: '8px',
      justifyContent: 'center',
      alignItems: 'baseline',
    },
    '&__footer': {
      gap: '8px',
      justifyContent: 'flex-end',
    },
  },
  '.product-row': {
    flexDirection: 'column',
    width: '150px',
    marginRight: theme.space[5],
    marginTop: theme.space[5],
  },
  '.product-image': {
    width: '150px',
    height: '150px',
  },
  '.product-text': {
    textAlign: 'center',
  },
  '.product-caption': {
    marginTop: theme.space[3],
  },
  '.buttons': {
    marginTop: '0.75rem',
  },
});
